import moment from 'moment';

export function momentToDate(dateEntree) {
  const decalageEnMinute = moment(dateEntree).utcOffset();
  const date = dateEntree.toDate();
  date.setHours(decalageEnMinute / 60);
  return date;
}

export function dateToIsoDateString(date) {
  return date.toISOString().split('T')[0]
}

export const nbMonthsBetweenDates = (dateA, dateB) => dateA && dateB ? moment(dateA).diff(dateB, 'month') : 1
